import dayjs from "dayjs";
import { getUser } from "shj-utils";

const getConfig = () => {
  const userInfo = getUser()
  return  {
    cacheDisabled: false,
    rowSelection: false,
    name: 'outboundCall_Workload',
    columns: [
      {
        title: '分公司',
        dataIndex: 'orgName',
        width: 180,
        ellipsis: true,
      },
      {
        title: '部门',
        dataIndex: 'deptName',
        width: 180,
        ellipsis: true,
      },
      {
        title: '员工',
        dataIndex: 'userName',
        width: 180,
        ellipsis: true,
      },
      {
        title: '工号',
        dataIndex: 'workerNumber',
        width: 180,
        hidden: true,
      },
      {
        title: '外呼总数',
        dataIndex: 'outTotal',
        width: 180,
      },
      {
        title: '外呼成功数',
        dataIndex: 'outSuccessNum',
        width: 180,
      },
      {
        title: '外呼成功率',
        dataIndex: 'outSuccessRate',
        width: 180,
        render: (v) => v ? v + '%' : v
      },
      {
        title: '外呼通话总时长',
        dataIndex: 'outCallTotalDuration',
        width: 180,
        ellipsis: true,
      },
      {
        title: '外呼通话平均时长',
        dataIndex: 'outCallAvgDuration',
        width: 180,
        ellipsis: true,
      },
      {
        title: '平均每小时通话数',
        dataIndex: 'avgCallNumPerHour',
        width: 180,
        hidden: true,
      },
      {
        title: '外呼时长大于15S通话数',
        dataIndex: 'outCallDurationMoreThan15Num',
        width: 180,
        hidden: true,
      },
      {
        title: '外呼时长大于30S通话数',
        dataIndex: 'outCallDurationMoreThan30Num',
        width: 180,
        ellipsis: true,
      },
      {
        title: '外呼时长大于60S通话数',
        dataIndex: 'outCallDurationMoreThan60Num',
        width: 180,
        hidden: true,
      },
    ],
    search: [
      {
        name: 'orgId',
        label: '分公司',
        itemType: 'select',
        data: 'companyList',
        labelKey: 'name',
        key: 'id',
        events: ['onChange:onCompanyChange'],
        disabled: userInfo?.userIdentity?.dataScope !== 'ALL',
      },
      {
        name: 'deptId',
        label: '部门',
        itemType: 'cascader',
        events: ['onChange:onDeptCodeChange'],
        key: 'id',
        labelKey: 'label',
        value: 'id',
        data: 'deptId',
        notFoundContent: '请选择公司或无匹配数据',
        changeOnSelect: true,
        expandTrigger: 'hover',
      },
      {
        name: 'userId',
        label: '员工',
        itemType: 'select',
        data: 'employ',
        labelKey: 'userName',
        key: 'ucenterUserId',
        notFoundContent: '请选择公司或无匹配数据',
      },
      {
        name: 'type',
        label: '外呼服务商',
        itemType: 'select',
        data: 'serviceList',
        labelKey: 'description',
        key: 'key',
      },
      {
        name: 'time',
        label: '外呼时间',
        itemType: 'autoDate',
      },
    ],
    searchInitialValues: {
      time: [dayjs().startOf('month'), dayjs()],
    },
  }
}

export const config = getConfig()